import Privacidad from './Privacidad'
export default Privacidad